import React from "react";
import { ClosedGroupIllustration } from "./closedGroupIllustration";

interface AccessModeIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
	closed: boolean;
}

export const AccessModeIndicator: React.FC<AccessModeIndicatorProps> = ({ closed, ...htmlProps }) => {
	return <div {...htmlProps}>{closed && <ClosedGroupIllustration />}</div>;
};
